/**
 * KitUI
 * Browser helpers and utilities.
 */

export function getDeviceInfo() {
  const hasTouch = 'ontouchstart' in document.documentElement;
  const hasTouchScreenPointer = window.matchMedia('(pointer:coarse)').matches;
  const isTouchScreen = hasTouch && hasTouchScreenPointer;
  const iOSRegex = /iPhone|iPad|iPod/i;
  const otherMobileRegex = /Android|webOS|BlackBerry|IEMobile|Opera Mini/i;

  // Warning: user agent testing should not be relied upon for anything but addressing strange device-specific browser quirks
  const isIOS = iOSRegex.test(navigator.userAgent);
  const isOtherMobile = otherMobileRegex.test(navigator.userAgent);
  const isMobile = hasTouch && (isIOS || isOtherMobile);

  return {
    isTouchScreen,
    isMobile,
    isIOS,
    isOtherMobile,
  };
}

/**
 * Method to return the actual offset of an element in page coordinates
 * Note: el.getBoundingClientRect() might actually be what you are looking for as getBoundingClientRect
 * calculates positioning in viewport coordinates which take both offset and transform coordinates
 *
 * @param el
 */
export const getRealOffset = (el: HTMLElement) => {
  let curEl: HTMLElement = el;
  let curTop = curEl.offsetTop;
  let curLeft = curEl.offsetLeft;
  if (curEl.offsetParent) {
    while ((curEl = curEl.offsetParent as HTMLElement)) {
      curLeft += curEl.offsetLeft;
      curTop += curEl.offsetTop;
    }
  }
  return {
    left: curLeft,
    top: curTop,
  };
};

export const updateBodyScrollState = (): void => {
  const allDialogs = document.querySelectorAll<HTMLElement>('.cp-modal-container');
  let anyVisibleDialogs = false;

  if (allDialogs.length) {
    allDialogs.forEach((el) => {
      // See jQuery soliution at https://blog.jquery.com/2009/02/20/jquery-1-3-2-released/#:visible.2F:hidden_Overhauled
      if (el.offsetWidth || el.offsetWidth) {
        anyVisibleDialogs = true;
      }
    });
  }
  if (anyVisibleDialogs) {
    document.body.classList.add('noscroll');
  } else {
    document.body.classList.remove('noscroll');
  }
};
